import { sendGTMEvent } from '@next/third-parties/google';
import { type EventLogger } from '@skin-seoul/utils';

export const gtmEventLogger: EventLogger = ({ event, params }) => {
  sendGTMEvent({ event, ...params });
};
